import { NearbyBillboardsMap } from '@/features/billboards/components/nearby/NearbyBillboardsMap';
import { useNearbyBillboardsPage } from '@/features/billboards/hooks/useNearbyBillboardsPage';
import { NEARBY_RADIUS_OPTIONS } from '@/features/billboards/utils/nearbyBillboardsUtils';

export function NearbyBillboardsPage() {
  const {
    userLocation,
    selectedRadius,
    setSelectedRadius,
    locationError,
    billboards,
    isPending,
    isError,
    handleRecenter,
  } = useNearbyBillboardsPage();

  return (
    <div className="mx-auto flex w-full max-w-6xl flex-col gap-4 text-[#3A3660]">
      <div className="flex flex-col gap-3">
        <div className="flex flex-col gap-3">
          <h1 className="m-0 text-[28px] sm:text-[32px] font-extrabold tracking-[-0.5px] text-[#3A3660]">
            Nearby Smart Screens
          </h1>

          <div className="flex max-w-full items-center gap-2 overflow-x-auto py-1 [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
            {NEARBY_RADIUS_OPTIONS.map((radius) => {
              const isActive = selectedRadius === radius;

              return (
                <button
                  key={radius}
                  type="button"
                  onClick={() => setSelectedRadius(radius)}
                  className={`h-9 shrink-0 cursor-pointer rounded-full px-4 text-[13px] inline-flex items-center transition-all ${
                    isActive
                      ? 'bg-gradient-to-r from-[#3B66B8] to-[#8156B4] text-white font-bold shadow-sm border-none'
                      : 'bg-white border border-[#EAE8F5] text-[#4A4670] font-semibold hover:border-[#8156B4]/40 hover:text-[#3B66B8]'
                  }`}
                >
                  {radius} km
                </button>
              );
            })}
          </div>
        </div>

        <div className="flex flex-wrap items-center justify-between gap-3 text-[13px] text-[#6A6688]">
          <p className="m-0 whitespace-nowrap text-[13px] text-[#6A6688]">
            Screens within {selectedRadius} km of your location
          </p>

          {!isPending ? (
            <span className="inline-flex w-fit items-center whitespace-nowrap rounded-full bg-[#DFE9FA] px-3 py-1 text-[11px] font-extrabold text-[#2B3E8A]">
              {billboards.length} screen{billboards.length === 1 ? '' : 's'} found
            </span>
          ) : null}
        </div>
      </div>

      {locationError ? (
        <p className="m-0 text-left text-xs font-medium text-amber-600">
          Location access denied. Showing screens around the default area.
        </p>
      ) : null}

      {isError ? (
        <p className="m-0 text-left text-xs font-medium text-red-500">
          Unable to load nearby screens. Please try again.
        </p>
      ) : null}

      {userLocation ? (
        <NearbyBillboardsMap
          userLocation={userLocation}
          billboards={billboards}
          radiusKm={selectedRadius}
          isLoading={isPending}
          onRecenter={handleRecenter}
        />
      ) : (
        <div className="flex h-[480px] sm:h-[520px] w-full items-center justify-center rounded-[24px] border border-[#EEEBF8] bg-[#F3F2F9] shadow-[0_10px_30px_rgba(60,40,120,0.05)]">
          <div className="flex flex-col items-center gap-3">
            <div className="h-10 w-10 animate-spin rounded-full border-4 border-[#8156B4]/20 border-t-[#8156B4]" />
            <p className="text-sm font-semibold text-[#6A6688]">
              Detecting your location...
            </p>
          </div>
        </div>
      )
    };
      <div className="flex flex-wrap items-center gap-5 text-left mt-1">
        <div className="flex items-center gap-2">
          <span className="inline-block h-3.5 w-3.5 rounded-full border-2 border-white bg-[#4285F4] shadow" />
          <span className="text-xs font-semibold text-[#6A6688]">
            Your location
          </span>
        </div>
        <div className="flex items-center gap-2">
          <span className="inline-block h-3.5 w-3.5 rounded-full bg-[#8156B4]" />
          <span className="text-xs font-semibold text-[#6A6688]">
            Smart screens
          </span>
        </div>
      </div>
    </div>
  );
}
